@if (courses() !== null && !error()) {
	<uc-main-header
		[heading]="headerTitle()"
		[description]="headerDescription()"
		backgroundStyle="bg-course-search"
		textColor="text-white"
		descriptionColor="text-white"
	>
		<div class="mt-8">
			<uc-course-search-bar
				[options]="degreeLevelOptions"
				[subject]="searchTerm()"
				[autoSuggestEnabled]="true"
				(enter)="onSearch($event)"
				placeholder="Search Courses"
				[searchLocation]="headerSearchBar"
			/>
		</div>
	</uc-main-header>

	<uc-filter-dark-overlay
		[showOverlay]="filterTogglerSrv.displayFilter"
		(click)="filterTogglerSrv.toggle(false)"
	/>

	@if (shouldDisplayCourses()) {
		<div
			class="container py-12 sm:pt-12 sm:pb-16 lg:overflow-visible"
			id="course-search-container"
		>
			<div class="flex justify-between w-full">
				<!-- filter -->
				<uc-course-search-filter
					class="flex-shrink-0 block lg:flex course-search-filter"
					[ngClass]="{
						open: filterTogglerSrv.displayFilter,
					}"
					[degree]="degree()"
					[location]="location()"
					[subject]="searchTerm()"
					[studyMode]="mode()"
					[ucasPoints]="ucaspts()"
					[showDegreeLevel]="true"
					(filterChange)="onFilterChange($event)"
					(filterReset)="onFilterReset()"
					(autosuggest)="onSearch($event)"
					(closeFilter)="filterTogglerSrv.toggle(false)"
					(clearingChange)="onClearingSelect()"
					[isClearingSearch]="false"
				/>

				<main class="w-full">
					@if (isLoading()) {
						<uc-universities-skeleton [filter]="false" />
					} @else {
						<div class="flex-grow w-full search-container">
							<uc-filter-sort-widget
								[total]="courses()?.total ?? 0"
								[totalPills]="filterPillsCount()"
								text="courses found"
								[studyLevel]="studyLevel()"
								(toggleFilter)="filterTogglerSrv.toggle()"
							/>
							<uc-course-search-result
								[resultLength]="courses()?.data?.length"
								[degreeLevel]="degree()"
								[relatedSubjects]="courses()?.related_subjects ?? []"
								[showIndividualUniCourses]="false"
								(relatedSubject)="onRelatedSubject($event)"
								[product]="studyLevel()"
								(studyLevelChange)="onClearingSelect()"
							>
								<uc-course-list
									[subjectKeywords]="courses()?.subject_keywords ?? []"
									[product]="studyLevel()"
									[unis]="courses()?.data ?? []"
									[searchTerm]="searchTerm()"
									[isHECoSSubject]="isHECoSSubject()"
									[degreeLevel]="degreeLevel().label"
									[region]="locationTitle()"
								/>
							</uc-course-search-result>

							<!-- load more  -->
							@if (showLoadMore()) {
								<uc-course-search-pagination
									[hasMorePages]="!!courses()?.has_more_pages"
									[isLoading]="isPaginationLoading()"
									[searchTerm]="searchTerm()"
									[page]="courses()?.current_page ?? 1"
									(loadMore)="onLoadMore($event)"
								/>
							}
						</div>
					}
				</main>
			</div>
		</div>
	}
} @else if (isLoading() && courses() === null) {
	<uc-universities-skeleton class="container block" />
} @else if (!isLoading() && error()) {
	<uc-course-search-error />
}

@if (degree() === 'degrees' && courses()?.data?.length) {
	<uc-directory-card-cta />
}
